import { createReducer, on } from '@ngrx/store';
import { MessagesState } from './messages.state';
import { MessagesActions } from './messages.actions';

const initialState: MessagesState = {
  messageEntities: []
};

export const messagesReducer = createReducer(
  initialState,
  on(MessagesActions.set_message_entites, (state, data): MessagesState => {
    return { ...state, messageEntities: data.entities };
  })
);
